import Router from 'next/router'

/**
 * リダイレクト先を保存する
 *
 * next.jsのルーティングのためパスを整形 以下詳細
 * https://github.com/vercel/next.js/pull/9837/files
 */
export function storeUri(obj = null) {
  if (!Router.router) return
  // ルーティング用のクエリパラメータ整形

  const queryPath = Object.entries(Router.router.query)
    .map(([key, value], index) => {
      return index === 0 ? `?${key}=${value}` : `&${key}=${value}`
    })
    .join('')
  // クエリを付加した実際に遷移するパス
  const pathWithQuery = Router.router.pathname + queryPath

  // ブラウザ表示上のパス
  const asPath = obj ? obj : Router.router.asPath

  localStorage.setItem(
    'redirectPath',
    JSON.stringify({ pathWithQuery, asPath })
  )
}

/**
 * リダイレクト先に遷移する
 */
export function popStoredUri() {
  const redirectPath = localStorage.getItem('redirectPath')

  const { pathWithQuery = null, asPath = null } = redirectPath
    ? JSON.parse(localStorage.getItem('redirectPath'))
    : {}
  localStorage.removeItem('redirectPath')

  return { pathWithQuery, asPath }
}
